import React from 'react';
import { Container } from 'reactstrap';

import AppLayoutPage from './AppLayoutPage';

const LayoutPage = () => {
  return (
    <Container>
      <AppLayoutPage />
    </Container>
  );
};

export default LayoutPage;
